module.exports = __webpack_public_path__ + "img/2.253572d3.webp";